/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ErrorContentInfo/view.blocks to change it.
import Body from 'DesignSystem/Body/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ErrorContentInfo({
  children,
  viewPath = "/DesignSystem/ErrorContentInfo",
  marginTop = 16,
  text = "Something went wrong. Please reload this page."
  
}) {
  return (<React.Fragment
>
<div
  data-testid="ErrorContentInfo.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z2miHOG': typeof marginTop === 'number' ? `${marginTop}px` : marginTop}}
 className={`views-block ${styles.Horizontal}`}
>
<Body
  viewPath={`${viewPath}/Body`}
 textOverflow="none"
 whiteSpace="wrap"
 color="rgba(247,130,112,1)"
 text={text}
/>
</div>
{children}
</React.Fragment>)
}